/**
 * <load-more-component>: fetches the next collection/search results page and
 * appends its products to the current grid, instead of Horizon's default
 * numbered pagination. Used when a product-grid is rendered with
 * `use_load_more: true` (see snippets/product-grid.liquid).
 */
class LoadMoreComponent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = async () => {
    const url = this.dataset.nextUrl;
    const button = this.button;
    if (!url || !button) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Loading…';

    try {
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('.product-grid > li');
      const currentGrid = document.querySelector('.product-grid');
      if (currentGrid && newItems.length) {
        currentGrid.append(...newItems);
      }

      const nextLoadMore = doc.querySelector('load-more-component');
      if (nextLoadMore?.dataset.nextUrl) {
        this.dataset.nextUrl = nextLoadMore.dataset.nextUrl;
        button.disabled = false;
        button.textContent = originalText;
      } else {
        this.remove();
      }

      window.history.pushState({}, '', url);
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
    }
  };
}

if (!customElements.get('load-more-component')) {
  customElements.define('load-more-component', LoadMoreComponent);
}
